import React, { ReactNode, memo } from 'react';
import { formatCurrency } from '../../utils/formatters.util';
import Slider from 'react-slick';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import WebImage from '../tailwind/WebImage';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { Link } from '@components/Link';

// import Badge from '@components/tailwind/Badge';

const INIT_ADDON = {
  colorId: null,
  id: null,
  itemColor: 'Select Color',
  baseRate: null,
  rateEach: null,
};

const sliderSettings = {
  slidesToShow: 4,
  slidesToScroll: 2,
  arrows: true,
  variableWidth: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        arrows: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: true,
      },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 3.25,
        slidesToScroll: 2,
        arrows: false,
      },
    },
  ],
};

const AccessoryPicker = ({ title, items, selection, setSelection, INIT = INIT_ADDON }) => {
  const selectionHandler = (item) => (e) => {
    e.preventDefault();

    if (item.colorId && item.colorId === selection.colorId) {
      setSelection(INIT);
      return;
    } else {
      setSelection(item);
    }
  };

  const isOnSale = selection && selection.rateEach !== selection.baseRate;
  // const discountPercent =
  //   (selection && Math.round(((selection.baseRate - selection.rateEach) / selection.baseRate) * 100)) ||
  //   false;

  return (
    <div>
      <div className='tw-flex tw-justify-between'>
        <div className='tw-flex tw-w-full tw-flex-col tw-gap-2'>
          <p className='tw-mb-0 tw-text-[15px] tw-font-bold tw-leading-none'>{title}</p>
          <p className='tw-mb-0 tw-flex tw-items-center tw-gap-1 tw-text-[15px] tw-font-bold tw-leading-none tw-text-body'>
            <span className='tw-font-normal tw-text-[#6F7070]'>Color</span>
            <span>{selection.itemColor}</span>
          </p>
          <p className='tw-mb-2 tw-text-[15px] tw-font-normal tw-leading-none tw-text-body'>
            {selection.colorId && `+${formatCurrency(selection.rateEach)}`}
          </p>
        </div>
        {/* 
        {discountPercent && discountPercent > 0 && (
          <div className='tw-shrink-0'>
            <Badge>{discountPercent}% OFF</Badge>
          </div>
        )} */}
      </div>

      <Slider
        {...sliderSettings}
        prevArrow={
          <SlickButtonFix>
            <BsArrowLeft className='tw-cursor-pointer' size={16} onClick={() => {}} />
          </SlickButtonFix>
        }
        nextArrow={
          <SlickButtonFix>
            <BsArrowRight className='tw-cursor-pointer' onClick={() => {}} size={16} />
          </SlickButtonFix>
        }
        adaptiveHeight={false}
        className='!tw-flex tw-items-center tw-gap-1'>
        {items.map((item) => (
          <OverlayTrigger key={item.id} overlay={<Tooltip>{item.itemColor}</Tooltip>}>
            <div className='tw-p-1'>
              <Link
                className={classNames(
                  'tw-relative tw-block tw-h-full tw-w-full tw-overflow-hidden tw-rounded-button tw-outline-none focus:tw-outline-none focus-visible:tw-outline-none',
                  {
                    'tw-border-2 tw-border-brand-black': item.colorId === selection.colorId,
                    'tw-border tw-border-neutrals-light-grey': item.colorId !== selection.colorId,
                  }
                )}
                href='#'
                onClick={selectionHandler(item)}
                title={item.itemColor}
                data-id={item.id}
                data-rate={formatCurrency(item.rateEach)}
                data-name={item.displayName}
                data-color={item.itemColor}
                data-sale-rate={item.rateEach}
                data-base-rate={item.baseRate}
                data-default={selection.colorId}
                key={item.id}>
                <WebImage
                  webImage={item.webImages.default.thumb}
                  alt={`${item.displayName} - ${item.itemColor}`}
                  className='img-fluid'
                />
              </Link>
            </div>
          </OverlayTrigger>
        ))}

        <OverlayTrigger overlay={<Tooltip>No thanks</Tooltip>}>
          <div className='tw-p-1'>
            <Link
              className={classNames(
                'select-none-miyo tw-relative tw-block tw-h-full tw-w-full tw-overflow-hidden tw-rounded-button tw-outline-none focus:tw-outline-none focus-visible:tw-outline-none',
                {
                  'tw-border-2 tw-border-brand-black': !!selection.colorId,
                  'tw-border tw-border-neutrals-light-grey': !selection.colorId,
                }
              )}
              href='#'
              onClick={selectionHandler(INIT)}
              data-action='clear'>
              <WebImage webImage={items[0].webImages.default.thumb} alt='' />
              <span className='select-none-icon'>
                <span className='visually-hidden'>No Thanks</span>
              </span>
            </Link>
          </div>
        </OverlayTrigger>
      </Slider>
    </div>
  );
};

export default memo(AccessoryPicker);

const SlickButtonFix = ({
  currentSlide,
  slideCount,
  children,
  ...props
}: {
  currentSlide?: any;
  slideCount?: any;
  children: ReactNode;
}) => (
  <span className='tw-shrink-0' {...props}>
    {children}
  </span>
);
